export const Features = (props) => {
  return (
    <div id="features" className="text-center">
      <div className="container">
        <div className="col-md-10 col-md-offset-1 section-title">
          <h2>{props.title}</h2>
          <p>{props.paragraph}</p>
        </div>
        <div className="row">
          {props.list?.map((d, i) => (
            <div key={`${d.title}-${i}`} className="col-md-3 col-sm-6">
              <div className="feature">
                <img src={d.icon} alt="..." className="feature-logo" />
                <h3>{d.title}</h3>
                <p>{d.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
